//
import { queryList } from '../api';
import { Message } from 'element-ui';
const index = {
  namespaced: true,
  state: {
    resp: {},
    total: null,
  },
  mutations: {
    QUERY_LIST(state, resp) {
      state.resp = resp.obj || {};
    }
  },
  actions: {
    async queryListInfo({ commit }, obj) {
      let resp = await queryList(obj);
      commit('QUERY_LIST', resp);
    }
  }
}

export default index



// WEBPACK FOOTER //
// ./src/page/mytask/mytask/store/index.store.js